module.exports = __webpack_public_path__ + "img/img4.dba983ca.jpg";